import DealerTermsAndConditionsHtml from './dealer.terms-and-conditions.html';

export function DealerService (
  $uibModal,
  $q, 
  $translate, 
  confirm, 
  sessionObjAPI, 
  workshopAPI
) {

  var Dealer = function (id) {
    this.id = id;
  }

  Dealer.prototype.grantAccess = function() {
    var self = this;
    var deferred = $q.defer();

    if (!self.id) {
      return $q.reject($translate.instant('JS_SPACE.DEALER.ENTER_CODE'));
    }



    return workshopAPI.get('/company/find_dealer_details', self.id).then(function (details) {
      if (details.company.branding_group == 'bosch') {

        $uibModal.open({
            templateUrl: DealerTermsAndConditionsHtml,
            controller: 'DealerTermsAndConditionsCtrl',
            windowClass: 'lg-modal',
            resolve: {
              settings: function() {
                return details.settings;
              },
              dealer: function() {
                return details.company;
              },
            }
          }).result.then(function (data) {
            return workshopAPI.get('/company/grant_dealer_access', self.id);
          }).then(function (data) {
            deferred.resolve(data);
          }, function () {
            deferred.reject();
          });

          return deferred.promise;
      }
      else {
        return confirm.generic($translate.instant('JS_SPACE.CONFIRM.AUTHORISE_DEALER', {name: details.company_name}));
      }
    }).then(function (result) {
      if (!result) {
        return workshopAPI.get('/company/grant_dealer_access', self.id);
      }
    }).then(function () {
      return sessionObjAPI.refresh();
    });
  };

  Dealer.prototype.revokeAccess = function() {
    var self = this;

    return confirm.generic($translate.instant('JS_SPACE.CONFIRM.REVOKE_DEALER')).then(function () {
      return workshopAPI.get('/company/revoke_dealer_access');
    });
  };

  return Dealer;
}